module.exports = __webpack_public_path__ + "img/menu-logo.5c92d157.png";